import ApiService from "@/api";
import { CreateNamespaceModel, CreateNamespaceResultModel, ResponseModel } from "../models";
import { mapCreateNamespaceRequest } from "./AdapterServiceMappers";

export class AdapterService {
  private readonly api = new ApiService();

  /**
   * * Создать область
   * @param request Запрос
   * @param projectId ID проекта
   * @returns
   */
  createNamespace(request: CreateNamespaceModel, projectId: number) {
    return new Promise<ResponseModel<CreateNamespaceResultModel>>(async (resolve) => {
      const result = new ResponseModel<CreateNamespaceResultModel>();

      await this.api.Main.ProjectNamespaceService.createAsync(
        mapCreateNamespaceRequest(request, projectId),
      )
        .then((resp) => {
          result.Value = new CreateNamespaceResultModel({
            ...request,
            Id: resp.Id,
            TaskCount: resp.TaskCount,
          });
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error("ERROR createNamespace", e);
          return resolve(result);
        });
    });
  }
}
